// @flow
import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import Dropdown, {
  DropdownTrigger,
  DropdownContent
} from 'react-simple-dropdown'
import { User } from '../../types'
import theme from '../../styles/theme'
import Avatar from '../Avatar'

const DropdownLink = styled(Link)`
  display: block;
  width: 100%;
  text-align: left;
  color: inherit;

  &:hover,
  &:focus {
    text-decoration: none;
    color: ${theme.primary.darken(0.1)};
  }
`

const DropdownButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  display: block;
  cursor: pointer;
  width: 100%;
  text-align: left;

  &:hover,
  &:focus {
    outline: none;
    color: ${theme.primary.darken(0.1)};
  }
`

const Email = styled.span`
  font-size: 90%;
  font-weight: bold;
  color: rgb(120, 130, 140);
`

const Divider = styled.hr`
  margin: 8px 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`

type Props = {
  user: User,
  onLogout: Function
}

class UserDropdown extends Component {
  props: Props
  dropdown: any

  render() {
    return (
      <Dropdown
        ref={(node) => {
          this.dropdown = node
        }}
      >
        <DropdownTrigger
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: '#666'
          }}
        >
          <Avatar
            size={30}
            email={this.props.user.email}
            style={{ marginRight: '10px' }}
          />
          <span className="fa fa-caret-down" />
        </DropdownTrigger>
        <DropdownContent className="dropdown-right">
          <div className="dropdown-item" style={{ background: 'transparent' }}>
            <Email>{this.props.user.email}</Email>
          </div>
          <Divider />
          <div className="dropdown-item">
            <DropdownLink to="/settings" onClick={() => this.dropdown.hide()}>
              Settings
            </DropdownLink>
          </div>
          <div className="dropdown-item">
            <DropdownLink to="/favorites" onClick={() => this.dropdown.hide()}>
              Favorites
            </DropdownLink>
          </div>
          <div className="dropdown-item">
            <DropdownLink to="/searches" onClick={() => this.dropdown.hide()}>
              Searches
            </DropdownLink>
          </div>
          <div className="dropdown-item">
            <DropdownLink
              to="/scheduled-tours"
              onClick={() => this.dropdown.hide()}
            >
              Tours
            </DropdownLink>
          </div>
          <div className="dropdown-item">
            <DropdownLink to="/offers" onClick={() => this.dropdown.hide()}>
              Offers
            </DropdownLink>
          </div>
          <Divider />
          <div className="dropdown-item">
            <DropdownButton type="button" onClick={this.props.onLogout}>
              Logout
            </DropdownButton>
          </div>
        </DropdownContent>
      </Dropdown>
    )
  }
}

export default UserDropdown



// WEBPACK FOOTER //
// ./src/components/UserDropdown/index.js